import { Outlet } from "react-router-dom";

export default function GoogleAuthenticator() {
  return (
    <>
      <div className="google-authenticator">
        <Outlet />
      </div>
    </>
  );
}
